import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import AlertItem from './AlertItem';
import OrderAlertTable from './OrderAlertTable';

class OrderSizeAlert extends Component {
  render() {
    const { alert } = this.props;
    const { value } = alert;
    const total = value.order ? value.order.total : value.checkout.total;
    const orders = value.order ? [value.order] : [value.checkout];

    return (
      <AlertItem
        alert={alert}
        date={moment(alert.date).format('MMMM Do, YYYY')}
        icon='cubes'
        title={(
          <div>
            <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
              {alert.buyer.name}
            </Link>
            {' '}placed an order for {' '}
            <strong className='u-colorRed'>
              {total.formatMoney()}
            </strong>
            {' '} from {alert.value.supplier_name}
          </div>
        )}
        content={(
          <OrderAlertTable includeExport={true} orders={orders} type={value.type} />
        )}
        {...this.props}
      />
    );
  }
}

OrderSizeAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default OrderSizeAlert;
